import url from '../helpers/url';
import { useDispatch, useSelector } from 'react-redux';
import {
    movieOverlaySetVisible,
    movieOverlaySetInVisible,
    ppvOverlaySetVisible,
    ppvOverlaySetInVisible,
} from '../store/reducers/movieOverlayScreenSlice';
import { cleanupUrlWithoutReload } from '@intigral/utils/lib/helpers/browser';
import { useLocation } from 'react-router-dom';
import { getPathNameWithoutLangPrefix } from '@intigral/utils';

export default function useToggleDetailOverlay() {
    const dispatch = useDispatch();
    const movieOverlay = useSelector((state: any) => state.movieOverlay);
    const location = useLocation();
    const showDetailOverlay = (params: { [key: string]: string }) => {
        if (movieOverlay?.isVisible) {
            closeDetailOverlay();
        }
        dispatch(movieOverlaySetVisible());
        url.insertParamsWithoutReload(params);
    };
    const closeDetailOverlay = () => {
        if (getPathNameWithoutLangPrefix(location.pathname) === 'play') {
            removeSearchParams(['movie', 'qitafRedirect', 'eventId']);
        } else {
            removeSearchParams(['movie', 'series', 'guid', 'qitafRedirect', 'season', 'eventId']);
        }
        dispatch(movieOverlaySetInVisible());
    };

    const showPpvOverlay = (params: { [key: string]: string }) => {
        if (movieOverlay?.isPpvVisible) {
            closeDetailOverlay();
        }
        dispatch(ppvOverlaySetVisible());
        url.insertParamsWithoutReload(params);
    };
    const closePpvOverlay = () => {
        removeSearchParams(['eventId']);
        dispatch(ppvOverlaySetInVisible());
    };

    const removeSearchParams = (params: string[]) => {
        params?.length > 0 &&
            params.map((item) => {
                item && cleanupUrlWithoutReload([item]);
            });
    };

    return { showDetailOverlay, closeDetailOverlay, removeSearchParams, showPpvOverlay, closePpvOverlay };
}
